export default __webpack_public_path__ + "static/media/network.ca424225.svg";